import { render, staticRenderFns } from "./LeaverRules.vue?vue&type=template&id=e6da5d4a&"
import script from "./LeaverRules.vue?vue&type=script&lang=ts&"
export * from "./LeaverRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports